import { InAppState } from "../base/InAppState";
import { LoginState } from "./LoginState";

import template from './LogoutTemplate.html';

export class LogoutState extends InAppState
{
    static ROUTE = '/logout';
    static ID = 'logout';

    async enter()
    {
        // Tear down the session first (clears token, drops the user, tells the
        // backend, switches the shell back to its logged-out, empty #main-wrapper)
        await this.app.destroySession();

        const host = this.app.container.querySelector( '#main-wrapper' ) || document.body;
        this.app.view.render( host, template );

        const backBtn = host.querySelector( '[data-id="btn-back-to-login"]' );
        if ( backBtn )
        {
            this.addEventListener( backBtn, 'click', ( e ) =>
            {
                e.preventDefault();
                this.app.router.redirect( LoginState.ROUTE );
            } );
        }
    }

    async exit()
    {
    }
}
